module.exports = __webpack_public_path__ + "img/entryText.8bd57dbf.png";